<template>
  <div class="wrapper" id="inicio">
    <parallax
      class="section page-header header-filter"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 md-xlarge-size-80 mx-auto text-center"
          >
            <img :src="imagenlogo" />
            <div class="buttons">
              <md-button
                class="md-twitter md-simple md-white md-lg md-just-icon ml-auto"
              >
              </md-button>
              <md-button
                href="javascript:void(0)"
                class="md-facebook md-simple md-white md-lg md-just-icon"
              >
                <i class="fab fa-facebook-square" />
              </md-button>
              <md-button
                href="javascript:void(0)"
                class="md-instagram md-simple md-white md-lg md-just-icon mr-auto"
              >
                <i class="fab fa-instagram" />
              </md-button>
              <md-button
                class="md-google md-simple md-white md-lg md-just-icon"
              >
              </md-button>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
        
           <galeria2 id="galeria2"></galeria2>
          <prueba id="servicios"></prueba>
        </div>
        <precios id="precios"></precios>
        <opiniones id="resena"></opiniones>
        <contacto id="contacto"></contacto>
        <clubhouse></clubhouse>
        <SocialChat icon :attendants="attendants " class="whatsapp-chat  " >
          <p slot="header">
            Click para ser atendido por WhatsApp con algunos de nuestros ejecutivos.
          </p>
          <template v-slot:button>
            <img
              src="https://raw.githubusercontent.com/ktquez/vue-social-chat/master/src/icons/whatsapp.svg"
              alt="icon whatsapp"
              aria-hidden="true"
            />
          </template>
          <small slot="footer">Horario de Atención: 8am a 6pm</small>
        </SocialChat>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import imagenlogo from "../assets/img/logo.png";
//import galeria from "./galeria";
import prueba from "./prueba";
//import opinion from "./opinion";
import precios from "./precios";
import contacto from "./contacto";
import opiniones from "./opiniones";
import clubhouse from "./clubhouse";
import { SocialChat } from "vue-social-chat";
import imagenwhat from "../assets/img/examples/camp.jpg";
import galeria2 from "./galeria2";


export default {
  components: {
    //galeria,
    galeria2,
    prueba,
    //  opinion,
    precios,
    contacto,
    opiniones,
    clubhouse,
    SocialChat,
    
  
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  bodyClass: "about-us",
  data() {
    return {
      imagenlogo,
      image: require("@/assets/img/bg7.jpg"),
      speciality: "",
      name: null,
      email: null,
      message: null,
      cardProfile3: {
        cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg"),
        cardProfile2: require("@/assets/img/faces/card-profile6-square.jpg"),
        cardProfile3: require("@/assets/img/faces/card-profile4-square.jpg"),
        cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg"),
      },
      attendants: [

        {
          
          app: "whatsapp" ,
          label: "Reservaciones", 
          name :  "Jose Luis" ,
          number: "52 1 7121512189",
          avatar: {
            src: require("@/assets/img/examples/brisaslogo.jpg"),
            alt: "Jose Luis",
           
          },
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}

.mt-2 {
  margin-top: 1.5rem;
}
.whatsapp-chat {
  --whatsapp: #46c056;
  --vsc-bg-header: var(--whatsapp);
  --vsc-bg-button: var(--whatsapp);
  --vsc-outline-color: var(--whatsapp);
}
</style>

